app.controller("FreshLayoutController", [
    "$scope", "$q", "$state", "$http", "StSubject", "Students", "SysParam", "$uibModal", "$stateParams", "AuthService", "NotificationService", "QuestionnairesService", "StaticData", "UserConfigService", "ProgramService", "usSpinnerService", "FreshModal", "$rootScope", "$transitions",
    function ($scope, $q, $state, $http, StSubject, Students, SysParam, $uibModal, $stateParams, AuthService, NotificationService, QuestionnairesService, StaticData, UserConfigService, ProgramService, usSpinnerService, FreshModal, $rootScope, $transitions) {
        $scope.layout = {
            menuOpened: false,
            profileOpened: false,
            profileDropdownOpened: false,
            notificationsOpened: false,
            desktopCalendarOpened: false,
            mobileCalendarOpened: false,
            mobileMenuOpened: false
        };

        $scope.selectedDate = new Date();
        $scope.isActiveProgram = false;

        var eventDates = [];

        StaticData.getSystemParam("subjectSelectionStatus").then(function (data) {
            Students.isActiveProgram().then(function (active) {
                $scope.isActiveProgram = active;
                $scope.subjectSelectionEnabled = data === 'enabled' && $scope.isActiveProgram;
            });
        });

        StaticData.getSystemParam("examsStatus").then(function (data) {
            $scope.examsEnabled = data === 'enabled';
        });

        $scope.$watch('selectedDate', function () {
            $http.get('/calendar-event/user/list/', { params: { date: $scope.selectedDate } })
                .then(function (res) {
                    return res.data;
                })
                .then(function (data) {
                    var now = new Date();
                    $scope.currentEvents = data.map(function (el) {
                        el.timeString = moment(el.time).format('hh:mm');
                        el.past = now > new Date(el.time);
                        return el;
                    });
                });
        });

        var calendarRefreshedDeferred = $q.defer();
        $scope.calendarRefreshPromise = calendarRefreshedDeferred.promise;

        $http.get('/calendar-event/user/dates')
            .then(function (res) {
                return res.data;
            })
            .then(function (data) {
                eventDates = data;
                calendarRefreshedDeferred.notify('change');
            });

        $scope.calendarOptions = {
            showWeeks: false,
            startingDay: 1,
            customClass: getDayEventClass

        };

        function getDayEventClass(data) {
            var date = data.date;
            var mode = data.mode;
            if (mode === 'day') {

                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                if (dayToCheck === new Date($scope.selectedDate).setHours(0, 0, 0, 0)) {
                    return '';
                }

                for (var i = 0; i < eventDates.length; i++) {

                    var eventDay = new Date(eventDates[i]).setHours(0, 0, 0, 0);

                    if (dayToCheck === eventDay) {

                        return 'event-checked';
                    }
                }
            }

            return '';
        }

        $scope.getNotifications = function () {
            NotificationService.received({}).then(function (data) {
                $scope.notifications = data.docs;
                var unreadNotifications = _.filter($scope.notifications, { state: 'unread' });
                $scope.unreadNotifyCount = unreadNotifications.length;

                var priorityNotification = _.find(unreadNotifications, function (record) {
                    return record.notification.priority > 3;
                });

                if (priorityNotification) {
                    $scope.open(priorityNotification);
                }

                usSpinnerService.stop("root");
            });
        };

        $scope.getNotifications();

        $scope.getQuestionnairesCount = function () {
            QuestionnairesService.getListByProfile($scope.profile._id).then(function (questionnaires) {
                $scope.questionnairesCount = questionnaires.length;
            });
        };

        $scope.$on('questionnairesCount', function () {
            $scope.getQuestionnairesCount();
        });

        $scope.getTime = function (item) {
            var now = new Date;
            var sendDate = new Date(item.createDate);
            var pastHours = Math.round((now.getTime() - sendDate.getTime()) / (60 * 60 * 1000));
            var pastMinutes = Math.round((now.getTime() - sendDate.getTime()) / (60 * 1000));

            if (pastHours < 1) return pastMinutes + " წუთის წინ";
            else if (1 < pastHours && pastHours < 24) return pastHours + " საათის წინ";
            else return item.notification ? item.notification.createDateString : '';
        };

        $scope.open = function (item, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "StudentNewNotificationWindowController",
                templateUrl: _pb + 'student-new/notification-window.html',
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            }).then(function () {
                //
            }, function () {
                //
            });
            $scope.mark(item);
        };

        $scope.mark = function (notification) {
            NotificationService.mark({
                notification: notification._id,
                state: 'read'
            }).then(function () {
                $scope.getNotifications();
                $rootScope.$broadcast('notificationCount', {});
            });
        };

        function fetchQuestionnaire() {
            QuestionnairesService.getInfoByProfile($scope.profile._id).then(function (data) {
                if (!data.data) {
                    return;
                }
                var questionnaire = data.data;
                FreshModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    controller: "QuestionnaireWindowController",
                    templateUrl: _pb + 'student-new/questionnaire-window.html',
                    resolve: {
                        params: function () {
                            return { questionnaire: questionnaire };
                        }
                    }
                });
            });
        }

        AuthService.getUserData().then(function (user) {
            $scope.user = user;
            $scope.email = user.email;
            $scope.layout.themeIsDark = user.userConfig.theme ? user.userConfig.theme === "dark" : false;

            $scope.profile = AuthService.pickStudentProfile(user);

            if (!user.photo && user.gender === 'male') user.defaultPhoto = "img/male.jpg";
            if (!user.photo && user.gender === 'female') user.defaultPhoto = "img/female.jpg";
            else if (!user.photo && !user.gender) user.defaultPhoto = "img/no_image.jpg";

            fetchQuestionnaire();
            $scope.getQuestionnairesCount();
            SysParam.getSysParam("financialSeason").then(function (param) {
                $scope.financialSeason = param.value;
                var paymentScheduleSelected = $scope.profile.info.scheduleSelectRequired == false || $scope.profile.info.scheduleSelected === $scope.financialSeason;
                var restrictedStates = ['student-new.docs', 'student-new.payment-schedule'];

                if (!paymentScheduleSelected && restrictedStates.indexOf($state.current.name) === -1 && $scope.profile.state === 'active') {
                    $state.go('student-new.payment-schedule');
                } else if ($state.current.name === 'student-new.payment-schedule' && paymentScheduleSelected) {
                    $state.go('student-new.index');
                }

                // ngUpgrade Phase 2: was $rootScope.$on('$stateChangeStart', …) — now a
                // $transitions hook. (`to` is the target state, as the old 2nd event arg was.)
                var deregisterPaymentGuard = $transitions.onBefore({}, function (trans) {
                    var to = trans.to();
                    var currentProfile = AuthService.pickStudentProfile(AuthService.user);
                    var isRestrictedPage = restrictedStates.indexOf(to.name) >= 0;
                    var paymentScheduleSelected = currentProfile.info.scheduleSelectRequired == false || currentProfile.info.scheduleSelected === $scope.financialSeason;
                    var isStudentPage = to.name.indexOf('student-new') === 0;

                    if (!paymentScheduleSelected && !isRestrictedPage && isStudentPage && $scope.profile.state === 'active') {
                        return trans.router.stateService.target('student-new.payment-schedule');
                    }
                });
                $scope.$on('$destroy', deregisterPaymentGuard);
            });
        });

        // TEMP CHANGE
        // var restrictedStates = ['student-new.payments'];

        // $rootScope.$on('$stateChangeStart', function(event, transition) {
        //     var currentProfile = AuthService.pickStudentProfile(AuthService.user);
        //     var paymentScheduleSelected = currentProfile.info.scheduleSelected === $scope.financialSeason;
        //     if(!paymentScheduleSelected && transition.name === 'student-new.payments') {
        //         event.preventDefault();
        //         $state.go('student-new.payment-schedule');
        //     }
        // });

        $scope.logout = function () {
            AuthService.logout().then(function () {
                $state.go("login");
            });
        };

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.gender = gender;
            $scope.genderMap = _.keyBy($scope.gender, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        $scope.toggleMenu = function () {
            $scope.layout.menuOpened = !$scope.layout.menuOpened;
        };

        $scope.closeMenu = function () {

        };

        $scope.toggleProfileDropdown = function () {
            $scope.layout.profileDropdownOpened = !$scope.layout.profileDropdownOpened;
        };

        $scope.toggleNotificationsDropDown = function () {
            $scope.layout.notificationsOpened = !$scope.layout.notificationsOpened;
        };

        $scope.openProfile = function () {
            // $scope.layout.profileOpened = true;
            $scope.layout.profileDropdownOpened = false;
            $state.go("student-new.profile")
        };

        $scope.closeProfile = function () {
            $scope.layout.profileOpened = false;
        };

        $scope.toggleTheme = function () {
            $scope.layout.themeIsDark = !$scope.layout.themeIsDark;
            UserConfigService.set({ key: 'theme', value: $scope.layout.themeIsDark ? 'dark' : 'light' });
            AuthService.user.userConfig.theme = $scope.layout.themeIsDark ? 'dark' : 'light';
        };

        $scope.highlightMobile = function (element) {
            if (element === 'home') {
                return $state.is('student-new.index');
            }
            if (element === 'notifications') {
                return $state.is('student-new.notifications');
            }
            if (element === 'calendar') {
                return $scope.layout.mobileCalendarOpened;
            }
            if (element === 'menu') {
                return $scope.layout.mobileMenuOpened;
            }
            return false;
        };

        $scope.showHomeMobile = function () {
            $state.go('student-new.index');
            $scope.layout.mobileMenuOpened = false;
            $scope.layout.mobileCalendarOpened = false;
        };

        $scope.showNotifications = function () {
            $state.go('student-new.notifications');
            $scope.layout.mobileMenuOpened = false;
            $scope.layout.mobileCalendarOpened = false;
            $scope.layout.notificationsOpened = false;
        };

        $scope.showMenuMobile = function () {
            $scope.layout.mobileMenuOpened = !$scope.layout.mobileMenuOpened;
            $scope.layout.mobileCalendarOpened = false;
        };

        $scope.closeMobileMenu = function () {
            $scope.layout.mobileMenuOpened = false;
        };

        $scope.showCalendarMobile = function () {

            $scope.layout.mobileMenuOpened = false;
            $scope.layout.mobileCalendarOpened = true;
        };

        $scope.showCalendarDesktop = function () {
            $scope.layout.desktopCalendarOpened = !$scope.layout.desktopCalendarOpened;
        };

        $scope.closeAll = function () {
            $scope.layout.desktopCalendarOpened = false;
            $scope.layout.menuOpened = false;
            $scope.layout.notificationsOpened = false;
            $scope.layout.profileDropdownOpened = false;
        };

        $scope.generateClass = function (state) {
            if (state === 'active') return 'btn green';
            if (state === 'pause') return 'btn orange';
            if (state === 'candidate') return 'btn orange';
            if (state === 'abiturient') return 'btn orange';
            if (state === 'stop') return 'btn red';
            if (state === 'end') return 'btn red';
            else return 'btn grey'
        };
    }
]);
